var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _use, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKm = function SvgKm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3A75C4",
    d: "M0 0h500v300H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h500v225H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h500v150H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC61E",
    d: "M0 0h500v75H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D8E33",
    d: "m0 300 250-150L0 0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 150,
    r: 67.5,
    fill: "#FFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 150,
    r: 67.5,
    fill: "#3D8E33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "km_svg__a",
    fill: "#FFF",
    d: "m100.01 89.2 7.36 22.588-19.258-13.949h23.776L92.63 111.788z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#km_svg__a",
    y: 32.208
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#km_svg__a",
    y: 64.417
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#km_svg__a",
    y: 96.625
  })));
};
export default SvgKm;